import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRequest } from "utils/httpClient";
import { RootState } from "../store";
import { getWithdrawalRequestsPath } from "utils/backend-path-builders";
import { WithdrawalRequest, PagedWithdrawalRequests } from "interfaces/commerce/withdrawal-request";

export interface WithdrawalRequestsState {
  withdrawalRequests: WithdrawalRequest[];
  fetchStatusState: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: WithdrawalRequestsState = {
  withdrawalRequests: [],
  fetchStatusState: "loading",
  error: null,
};

export const fetchWithdrawalRequests = createAsyncThunk<
  WithdrawalRequest[],
  void,
  { rejectValue: string }
>("withdrawalRequests/fetch", async (_, { rejectWithValue }) => {
  try {
    const response: WithdrawalRequest[] = await getRequest(getWithdrawalRequestsPath());
    return response || [];
  } catch (err) {
    console.error(err);
    return rejectWithValue("Failed to fetch withdrawal requests");
  }
});



const slice = createSlice({
  name: "withdrawalRequests",
  initialState,
  reducers: {
    clearWithdrawalRequestsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWithdrawalRequests.pending, (state) => {
      state.fetchStatusState = "loading";
      state.error = null;
    });
    builder.addCase(fetchWithdrawalRequests.fulfilled, (state, action) => {
      state.fetchStatusState = "succeeded";
      state.withdrawalRequests = action.payload.sort((a, b) => 
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      state.error = null;
    });
    builder.addCase(fetchWithdrawalRequests.rejected, (state, action) => {
      state.fetchStatusState = "failed";
      state.error = action.payload ?? "Something went wrong.";
    });

  },
});

export const getWithdrawalRequestsState: (state: RootState) => WithdrawalRequestsState = (state: RootState) => state.withdrawalRequests;

export const { clearWithdrawalRequestsState } = slice.actions;

export default slice.reducer; 